import { OfferCardSkeleton } from 'components-ui/src/offer_card/offer_card_skeleton'
import { Spacer3 } from 'components-ui/src/spacer/spacer'

export const SearchResultsSkeleton = () => {
  return (
    <>
      <OfferCardSkeleton />
      <Spacer3 />
      <OfferCardSkeleton />
      <Spacer3 />
      <OfferCardSkeleton />
    </>
  )
}
